export const updateLps = (
  pozycjeDS: any,
  pozycjeDsArr: any,
  startingIndex = 0
) => {
  pozycjeDsArr.forEach((x: any, i: number) => {
    pozycjeDS.push([
      { type: 'update', data: { ...x, Lp: i + startingIndex }, key: x.Id }
    ]);
  });
};
